// 用户

import UltMeta, { Meta } from "./UltMeta/index";

class Type extends UltMeta {
    NORMAL = new Meta(1, "普通用户");
    ADMIN = new Meta(2, "管理员");
}

export const TYPE = new Type();

class State extends UltMeta {
    ACTIVE = new Meta(1, "启用中");
    SUSPEND = new Meta(2, "停用中");
}

export const STATE = new State();

class Origin extends UltMeta {
    ZHIHAO = new Meta("ZHIHAO", "志豪集团企业人员");
    ENTERPRISE = new Meta("ENTERPRISE", "企业定制用户");
}

export const ORIGIN = new Origin();

/** 受邀状态 */
class Invitation extends UltMeta {
    NOT_CONFIRMED = new Meta(1, "未确认");
    CONFIRMED = new Meta(2, "已确认");
    REJECTED = new Meta(3, "已拒绝");
}
/** 受邀状态 */
export const INVITATION = new Invitation();

class SysUserType extends UltMeta {
    /** 采购方- 客户端 */
    OUTER = new Meta(1, "外部用户");
    /** 销售方 供应链端 */
    INNER = new Meta(2, "内部用户");
}

export const SYS_USER_TYPE = new SysUserType();

// 供应链，区分是SAAS,独立部署
class SystemType extends UltMeta {
    /** SAAS */
    SAAS = new Meta(1, "SAAS");
    /** 独立部署 */
    INDEPENDENT = new Meta(2, "独立部署");
}

export const SYSTEM_TYPE = new SystemType();
